import { gql } from '@apollo/client';

export const GET_CASE = gql`
  query GetCase($id: ID!) {
    case: getCase(id: $id) {
      id
      phase
      regimen
      artInitiationDate
      caseId
      adminNotes
      isARTClient
      caseWorker {
        id
        firstName
        lastName
      }
      nurse {
        id
        firstName
        lastName
      }
      peopleProfile {
        id
        firstName
        lastName
        name
        dateOfBirth
        age
        contactNumber
        whatsAppNumber
        identificationType
        nationalID
        passport
        whatsAppOptIn
        emailAddress
        consentToUseInformation
        physicalAddress
        streetNo
        streetName
        townshipVillageSuburb
        townCity
        postalCode
        alternativeAddress
        nextOfKinName
        nextOfKinSurname
        nextOfKinContactNumber
        nextOfKinAlternateContactNumber
        nonClient
        nonCommunicableDiseases
        householdId
        applicableNcds
        maternalAndChildHealth
        childNutrition
        maternalStage
        isARTTransferIn
        clientSourceOfIncomes {
          id
          name
        }
        householdSourceOfIncomes {
          id
          name
        }
        tb
        allergiesPresent
        allergyDetails
        homeLanguage {
          id
          name
        }
        populationGroup {
          id
          name
        }
        gender {
          id
          name
        }
        citizenship {
          id
          name
        }
        profileImage {
          id
          url
        }
      }
      intakeYears {
        id
        startDate
        endDate
        caseStatus
        caseId
        householdId
        householdCode
        nonClient
        clientStatus {
          id
          name
        }
        reasonForClosure {
          id
          name
        }
        otherReason
        nurse {
          id
          firstName
          lastName
        }
        caseWorker {
          id
          firstName
          lastName
        }
      }
      artStartDates {
        id
        startDate
        prescriptionDate
        prescriptionPeriod
        regimen
        nrti1Category {
          id
          name
        }
        nrti2Category {
          id
          name
        }
        nnrtiPiInsti {
          id
          name
        }
        additionalDrugs {
          id
          name
        }
      }
      documents {
        id
        name
        uploadedOn
        status
        expiryDate
        url
        type {
          id
          name
          endDate
          expiryDateRequired
          type
        }
        uploadedBy {
          id
          firstName
          lastName
        }
        file {
          id
          url
          name
        }
      }
      caseMonitoringStatuses {
        id
        effectiveDate
        status {
          id
          name
        }
        parentGroupOption {
          id
          name
        }
        category {
          id
          name
          childGroup {
            id
            name
          }
        }
      }
      customFieldValues {
        customFieldId
        name
        fieldType
        value
        readOnly
      }
      caseCategorisationStatuses {
        id
        effectiveDate
        endDate
        otherReason
        reasonForExit {
          id
          name
        }
        status {
          id
          name
        }
        parentGroupOption {
          id
          name
        }
        category {
          id
          name
          childGroup {
            id
            name
          }
        }
      }
      appointments {
        id
        clientTempId
        date
        time
        notes
        description
        followUpAppointment
        walkIn
        status
        practitioner {
          id
          firstName
          lastName
        }
        consultationTypes {
          id
          name
        }
        consultation {
          id
        }
        categories {
          id
          name
        }
      }
      consultations {
        id
        seenBy {
          id
          firstName
          lastName
        }
        activity {
          id
          name
        }
        categoryResponses {
          id
          cardType
          value
          serviceCategory {
            id
            name
          }
        }
        issue
        date
        time
        treatedBefore
        status
        rxFilled
        rx
        routineTreatments {
          id
          prescriptionDate
          vitaminA
          mebendazole
          nextPrescriptionDate
        }
      }
      immunisation {
        bcg
        opv0
        daptIpvHbHib1
        opv1
        pcv1
        rv1
        daptIpvHbHib2
        daptIpvHbHib3
        rv2
        pcv2
        measles1
        pcv3
        measles2
        daptIpvHbHib4
        td6Years
        td12Years
        hpv
        immunisationStatus
        nextImmunisationDate
        # immunisationService
      }
    }
  }
`;
